// utils/auth/AuthData.ts
import { User } from "./type";
import { getClientCookie } from "@/utils/cookies";

export function getAuthData() {
  let token = getClientCookie({
    name: "crm_auth_token",
    isParse: false,
    isCompress: false,
  });
  console.log("token:", token);

  // Fallback to environment variable if no token in cookies
  if (!token && import.meta.env.VITE_BEARER_TOKEN) {
    token = import.meta.env.VITE_BEARER_TOKEN;
    console.log("Using fallback token from VITE_BEARER_TOKEN");
  }

  const userData = getClientCookie({
    name: "crm_user_data",
    isParse: true,
    isCompress: true,
  });

  // userData is already parsed when isParse is true
  const user: User | null = userData || null;

  return {
    token,
    user,
    isAuthenticated: !!token,
  };
}

// Optional type for the return value
export type AuthData = {
  token: string | null;
  user: User | null;
  isAuthenticated: boolean;
};
